import { render, staticRenderFns } from "./toggleDesc.vue?vue&type=template&id=f6a03a7a&scoped=true"
import script from "./toggleDesc.vue?vue&type=script&lang=js"
export * from "./toggleDesc.vue?vue&type=script&lang=js"
import style0 from "./toggleDesc.vue?vue&type=style&index=0&id=f6a03a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a03a7a",
  null
  
)

export default component.exports